// NavDot.js
import { useTranslation } from 'gatsby-plugin-react-i18next';

const NavDot = ({ index, selected, onClick, dotImage, text }) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={() => onClick(index)}
      className={`paging-dot ${selected ? 'active' : ''}`}
    >
      <img loading="lazy" decoding="async" src={dotImage} alt={`Dot ${index + 1}`} />
      <span className="text">{t(text)}</span>
    </div>
  );
};

export default NavDot;
